import { createReducer, on } from '@ngrx/store';

import {
  clearSearchBarDataAction,
  selectArrivalDateAction
} from '@shared/base-search-bar/store/actions/search-bar.actions';
import { loadSearchDataSuccessAction } from '@shared/base-search-bar/store/actions/storage.actions';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';
import { isOutOfRangeDate } from '@shared/base-search-bar/helpers/calendar.helpers';
import { SearchData } from '@shared/base-search-bar/entities/search-data';

export const initialState: Date | null = null;

const isHotelOrPackages = (searchBy: SearchBy): boolean => {
  return searchBy === SearchBy.PACKAGES || searchBy === SearchBy.HOTELS;
}

export const arrivalDateReducer = createReducer(
  initialState,
  on(selectArrivalDateAction, (state, { date }) => date),
  on(loadSearchDataSuccessAction, (state, { data, searchBy, exchange }) => {
    if (exchange) {
      return data?.arrivalDate ? new Date(data.arrivalDate) : initialState;
    } else {
      return loadDataBySearch(state, data, searchBy);
    }
  }),
  on(clearSearchBarDataAction, () => initialState),
);

function loadDataBySearch(state: Date, data: SearchData, searchBy: SearchBy): Date {
  if (data?.arrivalDate) {
    return getDataBySearch(data, searchBy);
  } else {
    return state ? state : initialState;
  }
}

function getDataBySearch(data: SearchData, searchBy: SearchBy): Date {
  const arrival = new Date(data.arrivalDate);
  const departure = new Date(data.departureDate);
  const now = new Date();
  if (
    isHotelOrPackages(searchBy) &&
    (arrival?.toDateString() === departure?.toDateString() || isOutOfRangeDate(arrival, departure))
  ) {
    return initialState;
  } else {
    return arrival.getTime() >= now.getTime() ? new Date(data.arrivalDate) : initialState;
  }
}
